module.exports = __webpack_public_path__ + "static/media/5.ca0b1ac6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/bobruisk/5.jpg
// module id = 214
// module chunks = 0